import { CompositButton as Composit } from './CompositButton'

export * from './CompositButton'
export * from './menu'

export const Button = Object.assign({}, { Composit })
